








































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { AccountModule } from '@/store/modules/account';
import { GetUserInfo } from '@/pages/user/api/login';
import { GetCity, GetDistrict, GetProvinces, getObsToken } from '@/pages/user/api/common';
import { GetProductSizeOptions } from '@/pages/user/api/product';
import { CancelPsProductFavorite, CreatePsProductFavorite, GetPsProductFavoriteStatus } from '@/pages/user/api/sc';
import {
  ClosePayOrder,
  CreateNativePrepay,
  SampleOrderCreateResult,
  CreateSampleOrder,
  GetPayOrderStatus,
  GetSampleProductDetail,
  RedeemSampleCoupon,
} from '@/pages/user/api/sample-order';

type AreaOption = {
  code: string;
  name: string;
};

type ObsTokenResult = {
  host: string;
  key: string;
  policy: string;
  signature: string;
  accessid: string;
  cdn: string;
};

type SampleSizeOption = {
  sizeOptionSn: string;
  sizeName: string;
  unitPrice: number | string;
  sequence?: number;
  price?: number | string;
  size?: string;
  name?: string;
};

type ProductSizeOption = {
  sn: string;
  name: string;
  sequence?: number;
};

type SampleProductDetail = {
  productSn: string;
  name: string;
  imageUrl: string;
  detailImageUrls?: string[];
  studioName: string;
  proofNotice?: string;
  minQuantity?: number;
  stepQuantity?: number;
  sizePriceList?: SampleSizeOption[];
  priceList?: SampleSizeOption[];
};

function normalizeArray<T>(value: T[] | null | undefined): T[] {
  return Array.isArray(value) ? value : [];
}

function readQueryString(value: string | string[] | undefined): string {
  return Array.isArray(value) ? value[0] || '' : value || '';
}

function normalizeSourceCategoryCode(value: string | string[] | undefined): string {
  const code = readQueryString(value).trim();
  return /^[A-Za-z0-9_.:-]{1,128}$/.test(code) ? code : '';
}

function normalizeSourcePageNum(value: string | string[] | undefined): number {
  const pageNum = Number(readQueryString(value));
  return Number.isInteger(pageNum) && pageNum > 0 ? pageNum : 1;
}

function normalizeSizeOption(item: any, index: number): SampleSizeOption {
  return {
    sizeOptionSn: String(item.sizeOptionSn || item.optionSn || item.sizeSn || index),
    sizeName: String(item.sizeName || item.size || item.name || '--'),
    unitPrice: item.unitPrice !== undefined ? item.unitPrice : item.price !== undefined ? item.price : 0,
    sequence: Number(item.sequence || index),
    price: item.price,
    size: item.size,
    name: item.name,
  };
}

function createForm() {
  return {
    contactName: '',
    contactPhone: '',
    provinceCode: '',
    cityCode: '',
    districtCode: '',
    addressDetail: '',
    remark: '',
  };
}

@Component
export default class SampleApply extends Vue {
  pageLoading = false;
  submitLoading = false;
  couponLoading = false;
  uploading = false;

  uploadServer = '';
  uploadPayload = {};

  provinceOptions: AreaOption[] = [];
  cityOptions: AreaOption[] = [];
  districtOptions: AreaOption[] = [];
  sizeNameMap: Record<string, string> = {};

  productDetail: SampleProductDetail = {
    productSn: '',
    name: '',
    imageUrl: '',
    studioName: '',
    proofNotice: '',
    minQuantity: 1,
    stepQuantity: 1,
    sizePriceList: [],
  };

  selectedSizeOptionSn = '';
  activeDetailImageIndex = 0;
  quantity = 1;
  couponCode = '';
  couponApplied = false;
  couponMessage = '';
  couponAmount = 0;
  finalOriginalAmount: number | null = null;
  finalCouponAmount: number | null = null;
  finalPayableAmount: number | null = null;
  fileForm = {
    fileUrl: '',
    fileName: '',
    fileSize: 0,
  };

  payDialogVisible = false;
  payDialogLoading = false;
  payQrCodeDataUrl = '';
  currentOrderSn = '';
  currentOutTradeNo = '';
  currentPayExpireAt = '';
  currentPayStatus = '';
  currentPayAmount = 0;
  payStatusMessage = '';
  payPollingTimer: number | null = null;
  imagePreviewVisible = false;
  imagePreviewScale = 1;
  favorited = false;
  favoriteLoading = false;

  form = createForm();

  formRules = {
    contactName: [
      {
        validator: (_rule: any, value: string, callback: Function) => this.validateRequiredText(value, '请输入联系人', callback),
        trigger: 'blur',
      },
    ],
    contactPhone: [
      { required: true, message: '请输入联系电话', trigger: 'blur' },
      { validator: (_rule: any, value: string, callback: Function) => this.validatePhone(value, callback), trigger: 'blur' },
    ],
    provinceCode: [{ required: true, message: '请选择收货地区', trigger: 'change' }],
    addressDetail: [
      {
        validator: (_rule: any, value: string, callback: Function) => this.validateRequiredText(value, '请输入详细地址', callback),
        trigger: 'blur',
      },
    ],
  };

  beforeDestroy() {
    this.stopPayPolling();
  }

  async mounted() {
    if (!AccountModule.isLogined) {
      this.$message.warning('请先登录后再选购商品');
      this.$router.replace({
        path: '/login',
        query: {
          redirect: this.$route.fullPath,
        },
      });
      return;
    }

    const productSn = readQueryString(this.$route.query.productSn as string | string[] | undefined).trim();
    if (!productSn) {
      this.$message.warning('缺少商品信息');
      this.returnToSource('MISSING_PRODUCT', true);
      return;
    }

    this.pageLoading = true;
    try {
      try {
        await this.fetchProductDetail(productSn);
        await this.fetchFavoriteStatus(productSn);
      } catch (error) {
        this.$message.error('商品信息加载失败或已失效');
        this.returnToSource('INVALID_PRODUCT', true);
        return;
      }
      await Promise.all([this.fetchUserInfo(), this.fetchProvinceOptions(), this.fetchSizeOptionMap()]);
    } finally {
      this.pageLoading = false;
    }
  }

  get sizeOptions() {
    const source = normalizeArray<SampleSizeOption>(this.productDetail.sizePriceList).length
      ? normalizeArray<SampleSizeOption>(this.productDetail.sizePriceList)
      : normalizeArray<SampleSizeOption>(this.productDetail.priceList);
    return source
      .map((item, index) => {
        const normalized = normalizeSizeOption(item, index);
        if ((!normalized.sizeName || normalized.sizeName === '--') && normalized.sizeOptionSn) {
          normalized.sizeName = this.sizeNameMap[normalized.sizeOptionSn] || normalized.sizeName;
        }
        return normalized;
      })
      .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
  }

  get selectedSize() {
    return this.sizeOptions.find(item => item.sizeOptionSn === this.selectedSizeOptionSn) || null;
  }

  get selectedSizeName() {
    return this.selectedSize ? this.selectedSize.sizeName : '';
  }

  get minQuantity() {
    return Math.max(Number(this.productDetail.minQuantity || 1), 1);
  }

  get stepQuantity() {
    return Math.max(Number(this.productDetail.stepQuantity || 1), 1);
  }

  get originalAmount() {
    if (this.finalOriginalAmount !== null) {
      return this.finalOriginalAmount;
    }
    const unitPrice = this.selectedSize ? Number(this.selectedSize.unitPrice || 0) : 0;
    return unitPrice * Number(this.quantity || 0);
  }

  get payableAmount() {
    if (this.finalPayableAmount !== null) {
      return this.finalPayableAmount;
    }
    return Math.max(this.originalAmount - this.couponAmount, 0);
  }

  get isPayTerminal() {
    return ['PAID', 'CLOSED', 'FAILED', 'EXPIRED'].includes(this.currentPayStatus);
  }

  get productDetailImages() {
    const imageSet = new Set<string>();
    normalizeArray<string>(this.productDetail.detailImageUrls)
      .map(item => String(item || '').trim())
      .filter(Boolean)
      .forEach(item => imageSet.add(item));
    const mainImage = String(this.productDetail.imageUrl || '').trim();
    if (!imageSet.size && mainImage) {
      imageSet.add(mainImage);
    }
    return Array.from(imageSet);
  }

  get activeProductDetailImage() {
    const images = this.productDetailImages;
    if (!images.length) {
      return '';
    }
    const safeIndex = this.activeDetailImageIndex >= 0 && this.activeDetailImageIndex < images.length ? this.activeDetailImageIndex : 0;
    return images[safeIndex];
  }

  get imagePreviewTransform() {
    return `scale(${this.imagePreviewScale})`;
  }

  get proofNoticeList() {
    const content = String(this.productDetail.proofNotice || '')
      .split(/\n+/)
      .map(item => item.trim())
      .filter(Boolean);
    return content.length ? content : ['请上传清晰的打样文件', '建议分辨率 300dpi 以上', '提交前请确认尺寸与数量无误'];
  }

  get productIntroText() {
    return this.productDetail.studioName ? `专为艺术微喷设计，兼顾成像细腻度与色彩还原能力。` : '精选打样介质，兼顾成像细节与色彩还原。';
  }

  async fetchUserInfo() {
    const currentUserInfo = AccountModule.currentUserInfo || {};
    if ((currentUserInfo as any).nickname && (currentUserInfo as any).mobile) {
      await this.fillUserInfo(currentUserInfo);
      return;
    }

    try {
      const userInfo = await GetUserInfo();
      userInfo && AccountModule.setUserInfo(userInfo);
      await this.fillUserInfo(userInfo || {});
    } catch (error) {
      await this.fillUserInfo(currentUserInfo);
    }
  }

  fillUserInfo(userInfo: any) {
    this.form.contactName = userInfo.nickname || userInfo.name || this.form.contactName;
    this.form.contactPhone = userInfo.mobile || userInfo.phone || this.form.contactPhone;
    this.form.provinceCode = userInfo.provinceCode || this.form.provinceCode;
    this.form.cityCode = userInfo.cityCode || this.form.cityCode;
    this.form.districtCode = userInfo.districtCode || this.form.districtCode;
    this.form.addressDetail = userInfo.addressDetail || this.form.addressDetail;

    const taskList: Promise<any>[] = [];
    if (this.form.provinceCode) {
      taskList.push(this.fetchCityOptions(this.form.provinceCode));
    }
    if (this.form.cityCode) {
      taskList.push(this.fetchDistrictOptions(this.form.cityCode));
    }
    return Promise.all(taskList);
  }

  async fetchProvinceOptions() {
    try {
      const res = await GetProvinces();
      this.provinceOptions = normalizeArray<AreaOption>(res);
    } catch (error) {
      this.provinceOptions = [];
    }
  }

  async fetchCityOptions(code: string) {
    try {
      const res = await GetCity({ code });
      this.cityOptions = normalizeArray<AreaOption>(res);
    } catch (error) {
      this.cityOptions = [];
    }
  }

  async fetchDistrictOptions(code: string) {
    try {
      const res = await GetDistrict({ code });
      this.districtOptions = normalizeArray<AreaOption>(res);
    } catch (error) {
      this.districtOptions = [];
    }
  }

  async fetchSizeOptionMap() {
    try {
      const res = await GetProductSizeOptions();
      this.sizeNameMap = normalizeArray<ProductSizeOption>(res).reduce<Record<string, string>>((map, item) => {
        const sn = String(item.sn || '');
        if (sn) {
          map[sn] = String(item.name || '');
        }
        return map;
      }, {});
    } catch (error) {
      this.sizeNameMap = {};
    }
  }

  async fetchProductDetail(productSn: string) {
    const res = await GetSampleProductDetail({ productSn });
    const sizePriceList = normalizeArray<any>(res.sizePriceList);
    const priceList = normalizeArray<any>(res.priceList);
    this.productDetail = {
      productSn: res.productSn || productSn,
      name: res.name || '',
      imageUrl: res.imageUrl || '',
      detailImageUrls: normalizeArray<string>(res.detailImageUrls),
      studioName: res.studioName || '',
      proofNotice: res.proofNotice || '',
      minQuantity: Number(res.minQuantity || 1),
      stepQuantity: Number(res.stepQuantity || 1),
      sizePriceList: sizePriceList.map(normalizeSizeOption),
      priceList: priceList.map(normalizeSizeOption),
    };
    this.selectedSizeOptionSn = this.sizeOptions.length ? this.sizeOptions[0].sizeOptionSn : '';
    this.activeDetailImageIndex = 0;
    this.quantity = this.minQuantity;
  }

  async fetchFavoriteStatus(productSn: string) {
    try {
      const res = await GetPsProductFavoriteStatus([productSn]);
      const favoritedSet = new Set(normalizeArray<any>(res).map(item => item.targetSn || item.target_sn).filter(Boolean));
      this.favorited = favoritedSet.has(productSn);
    } catch (error) {
      this.favorited = false;
    }
  }

  async handleToggleFavorite() {
    const productSn = this.productDetail.productSn;
    if (!productSn || this.favoriteLoading) {
      return;
    }
    this.favoriteLoading = true;
    try {
      if (this.favorited) {
        await CancelPsProductFavorite({ productSn });
        this.favorited = false;
        this.$message.success('已取消收藏');
      } else {
        await CreatePsProductFavorite({ productSn });
        this.favorited = true;
        this.$message.success('已收藏');
      }
    } finally {
      this.favoriteLoading = false;
    }
  }

  selectProductDetailImage(index: number) {
    if (index < 0 || index >= this.productDetailImages.length) {
      return;
    }
    this.activeDetailImageIndex = index;
    this.resetImagePreviewScale();
  }

  switchProductDetailImage(offset: number) {
    const images = this.productDetailImages;
    if (images.length <= 1) {
      return;
    }
    this.activeDetailImageIndex = (this.activeDetailImageIndex + offset + images.length) % images.length;
    this.resetImagePreviewScale();
  }

  openImagePreview() {
    if (!this.activeProductDetailImage) {
      return;
    }
    this.resetImagePreviewScale();
    this.imagePreviewVisible = true;
  }

  closeImagePreview() {
    this.imagePreviewVisible = false;
    this.resetImagePreviewScale();
  }

  resetImagePreviewScale() {
    this.imagePreviewScale = 1;
  }

  handleImagePreviewWheel(event: WheelEvent) {
    const step = event.deltaY < 0 ? 0.2 : -0.2;
    const nextScale = Number((this.imagePreviewScale + step).toFixed(2));
    this.imagePreviewScale = Math.min(Math.max(nextScale, 0.5), 4);
  }

  handleSelectSize(sizeOptionSn: string) {
    this.selectedSizeOptionSn = sizeOptionSn;
    this.resetCouponState();
  }

  handleQuantityChange(value: number) {
    const quantity = Number(value || this.minQuantity);
    if (quantity < this.minQuantity) {
      this.quantity = this.minQuantity;
    } else {
      this.quantity = quantity;
    }
    this.resetCouponState();
  }

  async handleProvinceChange(code: string) {
    this.form.cityCode = '';
    this.form.districtCode = '';
    this.cityOptions = [];
    this.districtOptions = [];
    if (code) {
      await this.fetchCityOptions(code);
    }
  }

  async handleCityChange(code: string) {
    this.form.districtCode = '';
    this.districtOptions = [];
    if (code) {
      await this.fetchDistrictOptions(code);
    }
  }

  async handleBeforeUpload(file: any) {
    const suffix = this.getFileExtension(file.name);
    try {
      this.uploading = true;
      const res = (await getObsToken({ suffix })) as ObsTokenResult;
      this.uploadServer = res.host;
      this.uploadPayload = {
        key: res.key,
        policy: res.policy,
        signature: res.signature,
        AccessKeyId: res.accessid,
        success_action_status: '200',
      };
      file.originalUrl = res.cdn + res.key;
      file.originalName = file.name;
      return true;
    } catch (error) {
      this.resetUploadState();
      this.$message.error('上传凭证获取失败，请稍后重试');
      return false;
    }
  }

  handleUploadSuccess(_response: any, file: any) {
    this.fileForm.fileUrl = file.raw.originalUrl;
    this.fileForm.fileName = file.raw.originalName || file.name || '';
    this.fileForm.fileSize = Number(file.size || (file.raw && file.raw.size) || 0);
    this.resetUploadState();
    this.$message.success('样图上传成功');
  }

  handleUploadError() {
    this.resetUploadState();
    this.$message.error('文件上传失败，请稍后重试');
  }

  handleCouponInput() {
    this.resetCouponState();
  }

  async handleRedeemCoupon() {
    if (!this.selectedSizeOptionSn) {
      this.$message.warning('请选择打样尺寸');
      return;
    }
    if (!this.couponCode) {
      this.$message.warning('请输入优惠码');
      return;
    }

    this.couponLoading = true;
    try {
      const res = await RedeemSampleCoupon({
        productSn: this.productDetail.productSn,
        sizeOptionSn: this.selectedSizeOptionSn,
        quantity: this.quantity,
        couponCode: this.couponCode,
      });
      this.couponApplied = !!res.valid;
      this.couponAmount = Number(res.couponAmount || 0);
      this.couponMessage = res.message || (this.couponApplied ? '优惠码可用' : '优惠码不可用');
      if (res.originalAmount !== undefined && Number(res.originalAmount) !== this.originalAmount) {
        this.couponMessage = `${this.couponMessage}，请确认当前规格金额`;
      }
      if (this.couponApplied) {
        this.$message.success(this.couponMessage || '优惠码兑换成功');
      }
    } catch (error) {
      this.resetCouponState();
      this.couponMessage = (error && error.msg) || '优惠码校验失败，请稍后重试';
    } finally {
      this.couponLoading = false;
    }
  }

  async handleSubmit() {
    if (!this.selectedSizeOptionSn) {
      this.$message.warning('请选择打样尺寸');
      return;
    }

    const valid = await this.validateOrderForm();
    if (!valid) {
      return;
    }

    this.submitLoading = true;
    try {
      const res = await CreateSampleOrder({
        productSn: this.productDetail.productSn,
        sizeOptionSn: this.selectedSizeOptionSn,
        quantity: this.quantity,
        fileUrl: this.fileForm.fileUrl,
        fileName: this.fileForm.fileName,
        fileSize: this.fileForm.fileSize,
        contactName: this.form.contactName,
        contactPhone: this.form.contactPhone,
        provinceCode: this.form.provinceCode,
        cityCode: this.form.cityCode,
        districtCode: this.form.districtCode,
        addressDetail: this.form.addressDetail,
        couponCode: this.couponApplied ? this.couponCode : '',
        remark: this.form.remark,
      });
      if (!res) {
        throw new Error('创建订单失败');
      }
      await this.applyCreateOrderResult(res);
    } finally {
      this.submitLoading = false;
    }
  }

  async applyCreateOrderResult(res: SampleOrderCreateResult) {
    this.finalOriginalAmount = Number(res.originalAmount || 0);
    this.finalCouponAmount = Number(res.couponAmount || 0);
    this.finalPayableAmount = Number(res.payableAmount || 0);
    this.couponAmount = this.finalCouponAmount;
    if (res.couponCode) {
      this.couponCode = res.couponCode;
    }
    if (res.couponMessage) {
      this.couponMessage = res.couponMessage;
      this.$message.success(res.couponMessage);
    }
    this.couponApplied = this.finalCouponAmount > 0;
    if (res.payRequired) {
      this.openPayDialog(res);
      return;
    }
    this.showCreateSuccess(res.orderSn, this.finalPayableAmount);
  }

  openPayDialog(res: SampleOrderCreateResult) {
    this.currentOrderSn = res.orderSn || '';
    this.currentPayAmount = Number(res.payableAmount || 0);
    this.currentOutTradeNo = res.outTradeNo || '';
    this.payQrCodeDataUrl = res.qrCodeDataUrl || '';
    this.currentPayExpireAt = res.expireAt || '';
    this.currentPayStatus = res.payStatus || 'PAYING';
    this.payStatusMessage = this.resolvePayStatusMessage(this.currentPayStatus);
    this.payDialogVisible = true;
    this.startPayPolling();
  }

  async createNativePrepay(orderSn: string) {
    this.payDialogLoading = true;
    try {
      const res = await CreateNativePrepay({
        bizType: 'SAMPLE_ORDER',
        bizOrderSn: orderSn,
      });
      if (!res) {
        throw new Error('微信支付预下单失败');
      }
      this.currentOutTradeNo = res.outTradeNo || '';
      this.payQrCodeDataUrl = res.qrCodeDataUrl || '';
      this.currentPayExpireAt = res.expireAt || '';
      this.currentPayStatus = res.status || 'PAYING';
      this.payStatusMessage = this.resolvePayStatusMessage(this.currentPayStatus);
    } catch (error) {
      this.payDialogVisible = false;
      this.$message.error((error && error.msg) || '拉起微信支付失败，请稍后重试');
      throw error;
    } finally {
      this.payDialogLoading = false;
    }
  }

  startPayPolling() {
    this.stopPayPolling();
    this.payPollingTimer = window.setInterval(() => {
      this.pollPayStatus();
    }, 3000);
  }

  stopPayPolling() {
    if (this.payPollingTimer) {
      window.clearInterval(this.payPollingTimer);
      this.payPollingTimer = null;
    }
  }

  async pollPayStatus() {
    if (!this.currentOutTradeNo || !this.payDialogVisible) {
      return;
    }
    try {
      const res = await GetPayOrderStatus({ outTradeNo: this.currentOutTradeNo });
      this.applyPayStatus(res);
    } catch (error) {
      this.payStatusMessage = '支付状态查询中，请稍候...';
    }
  }

  applyPayStatus(res: any) {
    this.currentPayStatus = res.status || this.currentPayStatus;
    this.payStatusMessage = this.resolvePayStatusMessage(this.currentPayStatus, res.message);
    if (this.currentPayStatus === 'PAID') {
      this.stopPayPolling();
      this.handlePaySuccess();
      return;
    }
    if (['CLOSED', 'FAILED', 'EXPIRED'].includes(this.currentPayStatus)) {
      this.stopPayPolling();
    }
  }

  async handlePayRefresh() {
    if (!this.currentOrderSn) {
      return;
    }
    await this.createNativePrepay(this.currentOrderSn);
    if (!this.payPollingTimer) {
      this.startPayPolling();
    }
  }

  async handlePayCancel() {
    if (!this.currentOutTradeNo) {
      return;
    }
    this.payDialogLoading = true;
    try {
      await ClosePayOrder({ outTradeNo: this.currentOutTradeNo });
      this.currentPayStatus = 'CLOSED';
      this.payStatusMessage = this.resolvePayStatusMessage('CLOSED');
      this.stopPayPolling();
      this.payDialogVisible = false;
      this.$message.success('支付已取消');
      this.returnToSource('PAY_CANCELLED', true);
    } catch (error) {
      this.$message.error((error && error.msg) || '关闭支付失败，请稍后重试');
    } finally {
      this.payDialogLoading = false;
    }
  }

  handlePayDialogClose() {
    this.stopPayPolling();
  }

  handlePaySuccess() {
    this.payStatusMessage = '支付成功，正在返回列表...';
    window.setTimeout(() => {
      this.payDialogVisible = false;
      this.$message.success('支付成功');
      this.returnToSource('PAY_SUCCESS', true);
    }, 1200);
  }

  resolvePayStatusMessage(status: string, message?: string) {
    if (message) {
      return message;
    }
    if (status === 'PAID') {
      return '支付成功';
    }
    if (status === 'CLOSED') {
      return '支付已关闭';
    }
    if (status === 'EXPIRED') {
      return '二维码已过期，请刷新后重新支付';
    }
    if (status === 'FAILED') {
      return '支付失败，请刷新后重试';
    }
    return '请使用微信扫码完成支付';
  }

  showCreateSuccess(orderSn: string, payableAmount: number) {
    this.$alert(
      `订单号：${orderSn || '--'}
实付金额：¥${this.formatPrice(payableAmount)}`,
      '申请成功',
      {
        confirmButtonText: '返回列表',
        callback: () => {
          this.returnToSource('ORDER_COMPLETE', true);
        },
      }
    );
  }

  validateOrderForm() {
    const formRef = this.$refs.formRef as any;
    return new Promise<boolean>(resolve => {
      formRef.validate((valid: boolean) => {
        resolve(valid);
      });
    });
  }

  handleBack() {
    this.returnToSource('BACK');
  }

  resolveReturnLocation() {
    const source = readQueryString(this.$route.query.source as string | string[] | undefined);
    if (source === 'SC_FAVORITE') {
      return { path: '/myFavorite' };
    }
    if (source === 'PS_FAVORITE') {
      return { path: '/myFavorite', query: { tab: 'PS_PRODUCT' } };
    }
    if (source !== 'SUPPLY_CHAIN_CATEGORY') {
      return { path: '/printMediaList' };
    }

    const firstCategoryCode = normalizeSourceCategoryCode(this.$route.query.sourceFirstCategoryCode as string | string[] | undefined);
    if (!firstCategoryCode) {
      return { path: '/supplyChain' };
    }

    const query: Record<string, string> = {
      firstCategoryCode,
      pageNum: String(normalizeSourcePageNum(this.$route.query.sourcePageNum as string | string[] | undefined)),
    };
    const secondCategoryCode = normalizeSourceCategoryCode(this.$route.query.sourceSecondCategoryCode as string | string[] | undefined);
    if (secondCategoryCode) {
      query.secondCategoryCode = secondCategoryCode;
    }
    const categoryTitle = readQueryString(this.$route.query.sourceCategoryTitle as string | string[] | undefined)
      .trim()
      .slice(0, 100);
    if (categoryTitle) {
      query.categoryTitle = categoryTitle;
    }
    return {
      path: '/supplyChainCategory',
      query,
    };
  }

  returnToSource(_exitReason: string, replace = false) {
    const location = this.resolveReturnLocation();
    if (replace) {
      this.$router.replace(location);
      return;
    }
    this.$router.push(location);
  }

  validatePhone(value: string, callback: Function) {
    const normalized = String(value || '').trim();
    if (!normalized) {
      callback(new Error('请输入联系电话'));
      return;
    }
    if (!/^[0-9-+\s]{6,20}$/.test(normalized)) {
      callback(new Error('请输入有效联系电话'));
      return;
    }
    callback();
  }

  validateRequiredText(value: string, message: string, callback: Function) {
    if (!String(value || '').trim()) {
      callback(new Error(message));
      return;
    }
    callback();
  }

  resetCouponState() {
    this.couponApplied = false;
    this.couponAmount = 0;
    this.couponMessage = '';
    this.finalOriginalAmount = null;
    this.finalCouponAmount = null;
    this.finalPayableAmount = null;
  }

  resetUploadState() {
    this.uploading = false;
    this.uploadServer = '';
    this.uploadPayload = {};
  }

  getFileExtension(name: string) {
    const parts = String(name || '').split('.');
    return (parts[parts.length - 1] || '').toLowerCase();
  }

  formatPrice(value: number | string) {
    return Number(value || 0).toFixed(2);
  }

  formatDateTime(value: string) {
    if (!value) {
      return '--';
    }
    return String(value)
      .replace('T', ' ')
      .replace(/\.\d+$/, '');
  }
}
